// CJ - Dialog to show help from local assets/help files or remote URLs
//
import {
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Output,
    ViewChild,
    ChangeDetectionStrategy
} from "@angular/core";

import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { NgIf } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";


export const ERR_NONE = 0;
export const ERR_NO_INTENT = 101;
export const BUTTON_1 = 1;
export const BUTTON_2 = 2;
export const BUTTON_3 = 3;


@Component({
    selector: "app-progress-dialog",
    templateUrl: "./progress.dialog.html",
    styleUrls: ["./progress.dialog.css"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDialogModule,
        CdkDrag,
        CdkDragHandle,
        MatIconModule,
        NgIf,
        MatProgressBarModule,
        MatButtonModule,
    ],
})
export class ProgressDialogComponent {
  @Output() progressEvent = new EventEmitter<any>();

  @ViewChild("content", { static: true }) content: ElementRef;

  dialogTitle: string;
  dialogMessage: string;
  dialogProgress: number;
  dialogMode = "indeterminate";

  progressContext: number;
  helpContent: any;

  // progress-dialog.component.ts
  //public progress$ = new BehaviorSubject<number>(0);

  constructor(
    public dialogRef: MatDialogRef<ProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      message: string;
      progress: number;
      mode: 'determinate' | 'indeterminate';
      showCancel?: boolean;
    }
  ) {
    if (data) {
      this.dialogTitle = data.title;
      this.dialogMessage = data.message;
      this.dialogProgress = data.progress ?? 0;
      this.dialogMode = data.mode;

      /****
      #if (!data.mode) {
      #  this.dialogMode = "indeterminate";
      #} else {
      #  this.dialogMode = data.mode;
      #}
      ***/
    }
    // console.log('ProgressDialog data=', data);
  }

  // Optional helper method if you prefer explicit method calls over direct property assignment
  public updateProgress(val: number): void {
    this.data.progress = val;
  }

  waitAndClose(ms) {
    console.log("Closing progress in " + ms + "ms");
    setTimeout(() => {
      this.close();
    }, ms);
  }

  close() {
    // User canceled or quit operation
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  save() {
    // bundle the intent and data
    this.close();
  }

  scrollTop() {
    if (this.content.nativeElement) {
      this.content.nativeElement.scrollTop = 0;
    }
  }

  scrollBottom() {
    if (this.content.nativeElement) {
      const el = this.content.nativeElement;
      el.scrollTop = Math.max(0, el.scrollHeight - el.offsetHeight);
    }
  }
}

